import taxCenterGw from "../taxCenterGw";
import { SeasonBanner } from "../../types/seasonBanner.interface";

export const getSeasonBanner = async (): Promise<SeasonBanner> => {
  const { data } = await taxCenterGw.get<SeasonBanner>("/season-banner");
  return data;
};
